import { useRouter } from 'next/router'
import { useEffect } from 'react'

export default function CustomerAccountCreatePage() {
    const isClient = typeof window !== 'undefined'
    const pylotToken = isClient && window.localStorage.getItem('pylot_token')
    const router = useRouter()
    const path = pylotToken ? 'account' : router?.query.path

    useEffect(() => {
        if (!pylotToken) {
            if (path === 'create') {
                router.replace('/#show-signup-form')
            } else if (path === 'login') {
                router.replace('/#show-login-form')
            }
        } else {
            router.replace('/account')
        }
    }, [path])
}
